import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-full p-8 text-center"
}

import { computed, onMounted, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { useCateringAgent } from '@/composables/useCateringAgent'
import { mapRelationship } from '@/store/mappers'
import { cateringAgentTitle } from '@/view/ai/agentTypes'
import CateringOverview from '@/view/ai/CateringOverview.vue'


export default {
  __name: 'CateringHome',
  setup(__props) {

const loading = ref(true)
const { agent, load } = useCateringAgent()

const headerText = computed(() => {
  if (!agent.value) return 'Dashboard'
  const playbook = mapRelationship(agent.value.relationships?.agent_playbook?.data)
  return cateringAgentTitle(playbook?.attributes?.store_name)
})

onMounted(() =>
  load().finally(() => {
    loading.value = false
  })
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: headerText.value }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          (_unref(agent))
            ? (_openBlock(), _createBlock(CateringOverview, {
                key: 0,
                "agent-id": _unref(agent).id
              }, null, 8, ["agent-id"]))
            : (!loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-900" }, "No AI agent set up yet", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-2 max-w-md text-gray-500" }, " Set up your AI agent to start managing catering conversations and see its activity here. ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/agent-settings",
                    class: "mt-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(NeueButton, { type: "primary" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("Set up your AI agent", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}